import { TestimonialScreen } from '@/components/TestimonialScreen';

export default function TestimonialPage() {
  return <TestimonialScreen />;
}
